import { z } from 'zod';

// Drepturile unui plan (billing.plan_features.feature) — docs/16 §4.3, docs/23. Lista SQL
// (ultima din migrari, 20261108100000_roluri_cpv_judete.sql) e verificata de test/sql-sync.test.ts.
export const PLAN_FEATURES = [
  'seats', // cati utilizatori are firma
  'history_days', // cat istoric SEAP se vede
  'max_watchlists',
  'export_rows_month',
  'api_access',
  'cpv_codes', // cate coduri CPV urmareste firma (si deci ce date vede)
] as const;
export const PlanFeature = z.enum(PLAN_FEATURES);
export type PlanFeature = z.infer<typeof PlanFeature>;
